module.exports = __webpack_public_path__ + "img/boxes-stacked.01ed873d.svg";